import { History } from "history";

import { MediaDto } from "../../interfaces/media";
import {
  UserProfileDto,
  UpdateUserProfileRequest,
  ChangePasswordRequest,
} from "../../interfaces/user";

//#region Get User Profile

export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_USER_PROFILE_SUCCESS: any = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_ERROR: any = "GET_USER_PROFILE_ERROR";

export interface GetUserProfileAction {
  type: typeof GET_USER_PROFILE;
  payload: {};
}

export interface GetUserProfileSuccessAction {
  type: typeof GET_USER_PROFILE_SUCCESS;
  payload: UserProfileDto;
}

export interface GetUserProfileErrorAction {
  type: typeof GET_USER_PROFILE_ERROR;
  payload: any;
}
//#endregion

//#region Update User Profile

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_PROFILE_SUCCESS: any = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_ERROR: any = "UPDATE_USER_PROFILE_ERROR";
export const UPDATE_USER_PROFILE_RESET: any = "UPDATE_USER_PROFILE_RESET";

export interface UpdateUserProfileAction {
  type: typeof UPDATE_USER_PROFILE;
  payload: {
    request: UpdateUserProfileRequest;
    history: History;
  };
}

export interface UpdateUserProfileSuccessAction {
  type: typeof UPDATE_USER_PROFILE_SUCCESS;
  payload: UserProfileDto;
}

export interface UpdateUserProfileErrorAction {
  type: typeof UPDATE_USER_PROFILE_ERROR;
  payload: any;
}

export interface UpdateUserProfileResetAction {
  type: typeof UPDATE_USER_PROFILE_RESET;
  payload: null;
}

//#endregion

//#region Upload User Profile Image

export const UPLOAD_USER_PROFILE_PHOTO = "UPLOAD_USER_PROFILE_PHOTO";
export const UPLOAD_USER_PROFILE_PHOTO_SUCCESS: any =
  "UPLOAD_USER_PROFILE_PHOTO_SUCCESS";
export const UPLOAD_USER_PROFILE_PHOTO_ERROR: any =
  "UPLOAD_USER_PROFILE_PHOTO_ERROR";

export interface UploadUserProfilePhotoAction {
  type: typeof UPLOAD_USER_PROFILE_PHOTO;
  payload: {
    file: File;
  };
}
export interface UploadUserProfilePhotoSuccessAction {
  type: typeof UPLOAD_USER_PROFILE_PHOTO_SUCCESS;
  payload: MediaDto;
}

export interface UploadUserProfilePhotoErrorAction {
  type: typeof UPLOAD_USER_PROFILE_PHOTO_ERROR;
  payload: any;
}
//#endregion

//#region Change Password

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS: any = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR: any = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_RESET: any = "CHANGE_PASSWORD_RESET";

export interface ChangePasswordAction {
  type: typeof CHANGE_PASSWORD;
  payload: {
    request: ChangePasswordRequest;
    history: History;
  };
}

export interface ChangePasswordSuccessAction {
  type: typeof CHANGE_PASSWORD_SUCCESS;
  payload: null;
}

export interface ChangePasswordErrorAction {
  type: typeof CHANGE_PASSWORD_ERROR;
  payload: any;
}

export interface ChangePasswordResetAction {
  type: typeof CHANGE_PASSWORD_RESET;
  payload: null;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetUserProfileAction
  | GetUserProfileSuccessAction
  | GetUserProfileErrorAction
  | UpdateUserProfileAction
  | UpdateUserProfileSuccessAction
  | UpdateUserProfileErrorAction
  | UploadUserProfilePhotoAction
  | UploadUserProfilePhotoSuccessAction
  | UploadUserProfilePhotoErrorAction
  | ChangePasswordAction
  | ChangePasswordSuccessAction
  | ChangePasswordErrorAction
  | ChangePasswordResetAction;
